const banners_pt = require('./banners.json')
export default banners_pt